export const Text = ({ children, right }: { children: React.ReactNode, right?: boolean }) => (
  <div style={{
    fontSize: '14px',
    fontWeight: '300',
    ...(right && { textAlign: 'right' })
  }}>
    {children}
  </div>
);
